import app from 'flarum/forum/app';
import { getPerPage, isDiscussionPage, getDiscussionModel, getDiscussionId, getDiscussionSlug, getCurrentPage, getTotalPages, getNearFromUrl, navigateToDiscussionPage } from './paginationUtils';
let renderTimer = null;
let observer = null;
let lastRenderKey = '';
let lastAppliedPageKey = '';
let savedLoadNext = null;
let savedLoadPrevious = null;
let patchedStream = null;
function discussionPagerEnabled() {
  return !!app.forum.attribute('magicread_enable_discussion_pager');
}
function isMobilePager() {
  return window.matchMedia('(max-width: 600px)').matches;
}
function getDiscussionStream() {
  try {
    var _app$current, _app$current$get;
    return ((_app$current = app.current) == null || (_app$current$get = _app$current.get) == null ? void 0 : _app$current$get.call(_app$current, 'stream')) || null;
  } catch (_unused) {
    return null;
  }
}
function getPageBounds(page) {
  const perPage = getPerPage();
  const safePage = Math.max(1, page);
  const start = (safePage - 1) * perPage;
  const end = start + perPage;
  const near = start + 1;
  return {
    start,
    end,
    near
  };
}
function getVisiblePages(current, total) {
  const maxVisible = isMobilePager() ? 3 : 10;
  if (total <= maxVisible) {
    return Array.from({
      length: total
    }, (_, i) => i + 1);
  }
  let start = Math.max(1, current - Math.floor(maxVisible / 2));
  let end = start + maxVisible - 1;
  if (end > total) {
    end = total;
    start = Math.max(1, end - maxVisible + 1);
  }
  const pages = [];
  for (let i = start; i <= end; i++) pages.push(i);
  return pages;
}
function scrollPageTop() {
  const pager = document.querySelector('.MagicRead-DiscussionPagerHost--top');
  const nav = document.querySelector('.DiscussionPage-nav');
  const target = pager || nav;
  if (!target) {
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
    return;
  }
  const top = window.scrollY + target.getBoundingClientRect().top - 16;
  window.scrollTo({
    top: Math.max(0, top),
    behavior: 'auto'
  });
}
function ensureStreamPatched(stream) {
  if (patchedStream === stream) return;
  if (patchedStream) {
    restoreStream();
  }
  savedLoadNext = stream.loadNext;
  savedLoadPrevious = stream.loadPrevious;
  patchedStream = stream;
  stream.paused = true;
  stream.loadNext = () => {};
  stream.loadPrevious = () => {};
}
function restoreStream() {
  if (!patchedStream) return;
  if (savedLoadNext !== null) patchedStream.loadNext = savedLoadNext;
  if (savedLoadPrevious !== null) patchedStream.loadPrevious = savedLoadPrevious;
  patchedStream.paused = false;
  patchedStream = null;
  savedLoadNext = null;
  savedLoadPrevious = null;
}
function lockStreamToPage(stream, page) {
  const {
    start,
    end,
    near
  } = getPageBounds(page);
  const pageKey = "".concat(getDiscussionId(stream.discussion), "|").concat(page, "|").concat(start, "|").concat(end);
  ensureStreamPatched(stream);
  if (pageKey === lastAppliedPageKey) {
    return Promise.resolve();
  }
  lastAppliedPageKey = pageKey;
  stream.reset(start, end);
  return stream.loadRange(start, end).then(posts => {
    stream.show(posts);
    stream.visibleStart = start;
    stream.visibleEnd = Math.min(end, stream.count());
    stream.index = start;
    stream.number = near;
    stream.targetPost = null;
    stream.needsScroll = false;
    stream.animateScroll = false;
    m.redraw();
    requestAnimationFrame(scrollPageTop);
  });
}
function createPagerButton(options) {
  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = "Button MagicRead-DiscussionPager-btn ".concat(options.className || '').trim();
  btn.textContent = options.text;
  btn.title = options.title;
  btn.setAttribute('aria-label', options.title);
  if (options.active) {
    btn.classList.add('active');
    btn.setAttribute('aria-current', 'page');
  }
  if (options.disabled) {
    btn.disabled = true;
  } else if (options.onClick) {
    btn.addEventListener('click', e => {
      var _options$onClick;
      (_options$onClick = options.onClick) == null || _options$onClick.call(options);
      window.setTimeout(() => {
        var _e$currentTarget;
        (_e$currentTarget = e.currentTarget) == null || _e$currentTarget.blur();
      }, 0);
    });
    btn.addEventListener('touchend', e => {
      window.setTimeout(() => {
        var _e$currentTarget2;
        (_e$currentTarget2 = e.currentTarget) == null || _e$currentTarget2.blur();
      }, 0);
    });
  }
  return btn;
}
function createPagerHost(kind) {
  const host = document.createElement('div');
  host.className = "MagicRead-DiscussionPagerHost MagicRead-DiscussionPagerHost--".concat(kind);
  return host;
}
function ensurePagerHosts() {
  const root = document.querySelector('.DiscussionPage');
  if (!root) return {
    top: null,
    bottom: null
  };
  const stream = root.querySelector('.DiscussionPage-stream') || root.querySelector('.PostStream');
  if (!stream) return {
    top: null,
    bottom: null
  };
  let top = root.querySelector('.MagicRead-DiscussionPagerHost--top');
  let bottom = root.querySelector('.MagicRead-DiscussionPagerHost--bottom');
  if (!top) {
    var _stream$parentNode;
    top = createPagerHost('top');
    (_stream$parentNode = stream.parentNode) == null || _stream$parentNode.insertBefore(top, stream);
  }
  if (!bottom) {
    bottom = createPagerHost('bottom');
    if (stream.nextSibling) {
      var _stream$parentNode2;
      (_stream$parentNode2 = stream.parentNode) == null || _stream$parentNode2.insertBefore(bottom, stream.nextSibling);
    } else {
      var _stream$parentNode3;
      (_stream$parentNode3 = stream.parentNode) == null || _stream$parentNode3.appendChild(bottom);
    }
  }
  return {
    top,
    bottom
  };
}
function removePagerHosts() {
  restoreStream();
  document.querySelectorAll('.MagicRead-DiscussionPagerHost').forEach(el => el.remove());
  lastRenderKey = '';
  lastAppliedPageKey = '';
}
function enhanceLoadMoreButton(discussion, currentPage, totalPages) {
  const wrappers = Array.from(document.querySelectorAll('.PostStream-loadMore'));
  wrappers.forEach(wrapper => {
    wrapper.classList.add('MagicRead-LoadMoreWrap');
    const button = wrapper.querySelector('.Button, button');
    if (!button) return;
    button.classList.add('MagicRead-LoadMoreButton');
    if (currentPage >= totalPages) {
      button.disabled = true;
      return;
    }
    button.disabled = false;
    button.onclick = event => {
      event.preventDefault();
      event.stopPropagation();
      navigateToDiscussionPage(discussion, currentPage + 1);
      button.blur();
    };
  });
}
function buildPager(discussion, currentPage, totalPages) {
  const wrap = document.createElement('div');
  wrap.className = 'MagicRead-DiscussionPager';
  const controls = document.createElement('div');
  controls.className = 'MagicRead-DiscussionPager-controls';
  const pages = document.createElement('div');
  pages.className = 'MagicRead-DiscussionPager-pages';
  const jump = document.createElement('form');
  jump.className = 'MagicRead-DiscussionPager-jump';
  jump.setAttribute('novalidate', 'novalidate');
  controls.appendChild(createPagerButton({
    className: 'MagicRead-DiscussionPager-btn--nav',
    text: '«',
    title: String(app.translator.trans('forumaker-magicread.forum.pager.first')),
    disabled: currentPage <= 1,
    onClick: () => navigateToDiscussionPage(discussion, 1)
  }));
  controls.appendChild(createPagerButton({
    className: 'MagicRead-DiscussionPager-btn--nav',
    text: '‹',
    title: String(app.translator.trans('forumaker-magicread.forum.pager.prev')),
    disabled: currentPage <= 1,
    onClick: () => navigateToDiscussionPage(discussion, currentPage - 1)
  }));
  getVisiblePages(currentPage, totalPages).forEach(page => {
    pages.appendChild(createPagerButton({
      className: 'MagicRead-DiscussionPager-btn--page',
      text: String(page),
      title: "".concat(String(app.translator.trans('forumaker-magicread.forum.pager.page')), " ").concat(page),
      active: page === currentPage,
      onClick: () => navigateToDiscussionPage(discussion, page)
    }));
  });
  controls.appendChild(pages);
  controls.appendChild(createPagerButton({
    className: 'MagicRead-DiscussionPager-btn--nav',
    text: '›',
    title: String(app.translator.trans('forumaker-magicread.forum.pager.next')),
    disabled: currentPage >= totalPages,
    onClick: () => navigateToDiscussionPage(discussion, currentPage + 1)
  }));
  controls.appendChild(createPagerButton({
    className: 'MagicRead-DiscussionPager-btn--nav',
    text: '»',
    title: String(app.translator.trans('forumaker-magicread.forum.pager.last')),
    disabled: currentPage >= totalPages,
    onClick: () => navigateToDiscussionPage(discussion, totalPages)
  }));
  const input = document.createElement('input');
  input.className = 'FormControl';
  input.type = 'number';
  input.min = '1';
  input.max = String(totalPages);
  input.step = '1';
  input.value = String(currentPage);
  input.inputMode = 'numeric';
  input.setAttribute('aria-label', String(app.translator.trans('forumaker-magicread.forum.pager.input_label')));
  const fitInputWidth = () => {
    const len = Math.max(input.value.length, String(totalPages).length, 1);
    input.style.width = "".concat(Math.min(Math.max(len + 2.2, 4.6), 8), "ch");
  };
  input.addEventListener('input', fitInputWidth);
  fitInputWidth();
  const total = document.createElement('span');
  total.className = 'MagicRead-DiscussionPager-total';
  total.textContent = "/ ".concat(totalPages);
  const go = document.createElement('button');
  go.type = 'submit';
  go.className = 'Button MagicRead-DiscussionPager-btn MagicRead-DiscussionPager-btn--go';
  go.innerHTML = '<i class="fas fa-arrow-right"></i>';
  go.setAttribute('aria-label', String(app.translator.trans('forumaker-magicread.forum.pager.go')));
  go.title = String(app.translator.trans('forumaker-magicread.forum.pager.go'));
  jump.addEventListener('submit', e => {
    e.preventDefault();
    const wanted = parseInt(input.value, 10);
    if (!Number.isFinite(wanted)) return;
    const page = Math.min(Math.max(wanted, 1), totalPages);
    navigateToDiscussionPage(discussion, page);
    go.blur();
    input.blur();
  });
  wrap.appendChild(controls);
  jump.appendChild(input);
  jump.appendChild(total);
  jump.appendChild(go);
  wrap.appendChild(jump);
  return wrap;
}
function buildRenderKey(discussion, currentPage, totalPages) {
  return [getDiscussionId(discussion), getDiscussionSlug(discussion), currentPage, totalPages, getNearFromUrl(), location.pathname, isMobilePager() ? 'm' : 'd'].join('|');
}
function applyDiscussionPager() {
  const enabled = discussionPagerEnabled();
  const onDiscussion = isDiscussionPage();
  document.body.classList.toggle('MagicRead--discussionPagerEnabled', enabled && onDiscussion);
  if (!enabled || !onDiscussion) {
    removePagerHosts();
    return;
  }
  const discussion = getDiscussionModel();
  const stream = getDiscussionStream();
  if (!discussion || !stream) {
    removePagerHosts();
    return;
  }
  const totalPages = getTotalPages(discussion);
  const currentPage = getCurrentPage(totalPages);
  const renderKey = buildRenderKey(discussion, currentPage, totalPages);
  const {
    top,
    bottom
  } = ensurePagerHosts();
  if (!top || !bottom) return;
  lockStreamToPage(stream, currentPage).then(() => {
    enhanceLoadMoreButton(discussion, currentPage, totalPages);
  });
  if (renderKey === lastRenderKey && top.childElementCount > 0 && bottom.childElementCount > 0) {
    return;
  }
  lastRenderKey = renderKey;
  top.replaceChildren(buildPager(discussion, currentPage, totalPages));
  bottom.replaceChildren(buildPager(discussion, currentPage, totalPages));
}
export function scheduleDiscussionPagerRender(delay) {
  if (delay === void 0) {
    delay = 0;
  }
  if (renderTimer) window.clearTimeout(renderTimer);
  renderTimer = window.setTimeout(() => {
    applyDiscussionPager();
  }, delay);
}
export function mountDiscussionPager() {
  var _ref;
  if (observer) return;
  observer = new MutationObserver(mutations => {
    if (!discussionPagerEnabled() || !isDiscussionPage()) return;
    const shouldReact = mutations.some(mutation => Array.from(mutation.addedNodes).some(node => {
      var _node$closest, _node$matches, _node$querySelector;
      if (!(node instanceof HTMLElement)) return false;
      if ((_node$closest = node.closest) != null && _node$closest.call(node, '.MagicRead-DiscussionPagerHost')) return false;
      return ((_node$matches = node.matches) == null ? void 0 : _node$matches.call(node, '.DiscussionPage, .DiscussionPage-stream, .DiscussionPage-nav, .PostStream, .PostStream-item, .PostStream-loadMore')) || !!((_node$querySelector = node.querySelector) != null && _node$querySelector.call(node, '.DiscussionPage, .DiscussionPage-stream, .DiscussionPage-nav, .PostStream, .PostStream-item, .PostStream-loadMore'));
    }));
    if (!shouldReact) return;
    scheduleDiscussionPagerRender(30);
  });
  const root = (_ref = document.querySelector('.DiscussionPage')) != null ? _ref : document.body;
  observer.observe(root, {
    childList: true,
    subtree: true
  });
}
export function unmountDiscussionPager() {
  restoreStream();
  if (renderTimer) {
    window.clearTimeout(renderTimer);
    renderTimer = null;
  }
  if (observer) {
    observer.disconnect();
    observer = null;
  }
  removePagerHosts();
}
flarum.reg.add('forumaker-magicread', 'forum/components/discussionPager', { scheduleDiscussionPagerRender: scheduleDiscussionPagerRender,mountDiscussionPager: mountDiscussionPager,unmountDiscussionPager: unmountDiscussionPager, });